// extracted by mini-css-extract-plugin
export var option = "_48-1";
export var optionActive = "_48-2";
export var pill = "_48-0";